// @flow
export const UPDATE_STEP_ERRORS = 'g/progressTracker/UPDATE_STEP_ERRORS';
export const VALIDATE_STEPS = 'g/progressTracker/VALIDATE_STEPS';

export default {
    UPDATE_STEP_ERRORS,
    VALIDATE_STEPS,
};
